export default "__VITE_ASSET__CdVydS9n__"